<template>
</template>

<script>
export default {
    created: function () {
        window.location.href='/404';
    },
  }
</script>